require(`./lbToggle.${process.env.APP_INITIAL}.scss`);

const $inject = [];

const lbToggle = {
  controller: 'lbToggleCtrl as vm',
  template: require('./lbToggle.html'),
  bindings: {
    isActive: '=',
    onChange: '&'
  }
};

lbToggle.$inject = $inject;

export default lbToggle;




// WEBPACK FOOTER //
// ./src/components/lbToggle/lbToggle.js